import * as ReactDOMClient from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import Layout from "../shared/Layout";

import "./styles/client.sass"
import "./styles/general.sass"

const documentTitle = process.env.MONGO_DB_IN_USE == 'UserDB' ?  'Trained By Turp' : 'Body By Jim Reyes';
document.title = documentTitle;

const favicon = document.getElementById('faviconId');


//These aren't working for some reason :(
//In fact, when we do this, the program treats it like there isn't a favicon.
// favicon.setAttribute("href", '../client/assets/photos/jimReyesLogo.png')
// document.link.href = imgThing;

//Check for title

const root = document.getElementById("root");
// ReactDOMClient.createRoot(root).render(
//   <BrowserRouter>
//     <Layout />
//   </BrowserRouter>
// );
ReactDOMClient.hydrateRoot(
  root,
  <BrowserRouter>
    <Layout />
  </BrowserRouter>
);
